module.exports = __webpack_public_path__ + "static/media/lightning-grey.ecb51705.svg";